<div class="row pt-3 main-div" *ngIf="progressbarStatus">
  <div class="col-3 col-sm-2 offset-sm-4 col-md-2 offset-md-4 col-lg-2 col-xl-2 offset-xl-8 offset-lg-8 offset-2">
    <h6 class="pull-right download">Please Wait...
      <span class="fa-3x">
        <i class="fa-solid fa-sync fa-spin"></i>
      </span>
    </h6>
  </div>
  <div class="col-7 col-sm-6 col-md-6 col-lg-2 col-xl-2 px-4">
    <h6 class="pull-right download">Your download is currently under progress.</h6>
  </div>
</div>
